import {createActions} from 'client/framework';

export default createActions(null, ['UPDATE_RESPONSE', 'LOAD_GUESS', 'SAVE_CALLBACK']);
